import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Fab } from '@mui/material';
import { observer } from 'mobx-react-lite';

import refresh from 'assets/img/bottomNav/refresh.svg';
import tik from 'assets/img/bottomNav/tik.svg';
import disableNfc from 'assets/img/bottomNav/scan_inactive.svg';
import scanDefault from 'assets/img/scan-default.svg';
import { scanButtonTypes } from 'modules/scan/types';
import { scanStore } from 'store/mobx';

function ScanButton({ route, isActive }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { scanButtonStatus } = scanStore;

  const svgs = {
    default: scanDefault,
    blockClick: scanDefault,
    retry: refresh,
    finishedOk: scanDefault,
    success: tik,
    disabled: disableNfc
  };
  const isEnabled =
    scanButtonStatus === scanButtonTypes.default ||
    scanButtonStatus === scanButtonTypes.retry;

  const onClickHandler = () => {
    navigate(route);
    scanStore.reset_Scan_Handler(scanButtonTypes.blockClick);
    if (scanButtonStatus === scanButtonTypes.retry) {
      scanStore.startWebviewConnection();
    }
  };

  useEffect(() => {
    if (pathname !== route) {
      scanStore.reset_Scan_Handler();
    }
  }, [pathname]);

  return (
    <Fab
      sx={{
        width: '58px',
        height: '58px',
        background: '#FFFFFF !important',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.16)',
        '&:disabled': {
          boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.16)'
        }
      }}
      disabled={!isEnabled}
      onClick={onClickHandler}
    >
      <InnerStyle showAnimation={isActive}>
        <div className={`scan-${scanButtonStatus}`}>
          <img src={svgs[scanButtonStatus]} alt="" />
        </div>
      </InnerStyle>
    </Fab>
  );
}
export default observer(ScanButton);

const InnerStyle = styled.div`
  border: 1px solid #fff;
  width: 100%;
  height: 100%;
  border-radius: 50%;

  div {
    display: grid;
    place-items: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #f5f5f5;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3) inset;
  }

  .scan-default,
  .scan-blockClick {
    background: linear-gradient(
      130deg,
      #753cbe 20.24%,
      #3cc0c3 80.49%
    ) !important;
    animation: ${({ showAnimation }) =>
      showAnimation ? 'spin 3s linear infinite' : ''};
  }

  .scan-retry {
    background: #753cbe;
  }

  .scan-success {
    background: #3cc0c3;
  }

  .scan-disabled {
    background: #ebebeb !important;
  }

  .scan-finishedOk {
    background: #3cc0c3;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
